module.exports = __webpack_public_path__ + "static/media/donate-face.3e68c58e.jpg";